"use client"

import { HeroBannerWithBreadcrumbContent } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/HeroBannerWithBreadcrumb/components/HeroBannerWithBreadcrumbContent"
import { t } from "@/languages/i18n"
import { getLocaleHomeHref } from "@/lib/locale-utils"
import { usePathname } from "next/navigation"
import NormalContent from "./normal-content"

const DEFAULT_PAGE_COVER =
  "https://d300nzfp1n1jsy.cloudfront.net/photo_2023_07_01_11_26_54_0cd5ebe5f5.webp"

interface StandardPageContentProps {
  content: string
  locale?: string
  title: string
  coverUrl?: string
}

export default function StandardPageContent({ content, locale = "vi", title, coverUrl }: StandardPageContentProps) {
  const pathname = usePathname()

  return (
    <article>
      <HeroBannerWithBreadcrumbContent
        id="standard-page-hero-banner"
        breadcrumb={[
          { title: t("Trang chủ"), link: getLocaleHomeHref(locale) },
          { title, link: pathname },
        ]}
        image={coverUrl || DEFAULT_PAGE_COVER}
        title={title}
      />

      <div className="mx-auto mb-[5.875rem] mt-[3.75rem] w-full max-w-[82.5rem] p-4">
        <NormalContent content={content} tableOfContents={[]} className="text-base leading-[1.55] text-[#333]" />
      </div>
    </article>
  )
}
